import { Seo } from './../_models/seo';
import { TranslationsService } from './_services/translations/translations.service';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { loadTranslations } from '@angular/localize';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter, map, mergeMap, Observable, startWith } from 'rxjs';
import { SeoService } from './_services/seo/seo.service';
import {isPlatformBrowser} from "@angular/common";
import { AppChatService } from './_services/app/app-chat.service';
import { splitLocalePrefix } from './_shared/locale/detect-locale';
import { buildLangHrefs, readCurrentUrlOnce } from './_shared/locale/current-url';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'Drzew Wiśni';
  static isBrowser = new BehaviorSubject<boolean>(true);
  currentLang$: Observable<string>;
  // True na trasach /admin — ukrywa przełącznik języka (admin zawsze po polsku).
  isAdminRoute$: Observable<boolean>;
  // Adresy obu wersji jezykowych BIEZACEJ strony (T8).
  //
  // 🔴 Liczone PRZY KAZDEJ NAWIGACJI, nie raz w konstruktorze. Poprzednia wersja
  // przypisywala to pole jednorazowo, a app-root zyje tyle co dokument i kazda
  // nawigacja w aplikacji jest nawigacja SPA — wiec po pierwszym kliknieciu w menu
  // przelacznik dalej wskazywal strone, NA KTORA UZYTKOWNIK WSZEDL (wejscie na '/',
  // klik w "Menu" -> href EN nadal '/en/'). Test czystej funkcji buildLangHrefs byl
  // przez caly ten czas zielony; dowodem jest dopiero test komponentowy
  // (app-lang-switch.spec.ts, sekcja "PO NAWIGACJI SPA").
  //
  // Zrodlem jest WLASNY serializowany wynik routera (urlAfterRedirects), a nie
  // ponowny odczyt PlatformLocation: to ten sam string, ktory router pokazuje w
  // pasku adresu (z prefiksem '/en' doklejonym przez LocaleUrlSerializer), wiec
  // przelacznik i serializer nie moga sie rozjechac nawet po redirectach.
  // buildLangHrefs jest idempotentne wobec wejscia juz prefiksowanego (przypiete
  // w app-lang-switch.spec.ts), wiec '/en' nie dubluje sie do '/en/en'.
  readonly langHref$: Observable<Record<'pl' | 'en', string>>;

  constructor(
    private router: Router,
    private translationsService: TranslationsService,
    private changeRef: ChangeDetectorRef,
    private seoService: SeoService,
    private activatedRoute: ActivatedRoute,
    private appChat: AppChatService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    AppComponent.isBrowser.next(isPlatformBrowser(platformId));
    this.currentLang$ = this.translationsService.getLanguage();
    // router.url / urlAfterRedirects sa SERIALIZOWANE, wiec na drzewie EN niosa
    // prefiks ('/en/menu'). Zdejmujemy go tym samym parserem, inaczej warunek
    // '/admin' bylby prawdziwy tylko na PL (dzis bez skutku, bo /en/admin/** i tak
    // konczy na /en/404 — ale to przypadek, nie wlasnosc).
    this.isAdminRoute$ = this.router.events.pipe(
      filter((val): val is NavigationEnd => val instanceof NavigationEnd),
      map((val) => AppComponent.isAdminUrl(val.urlAfterRedirects)),
      startWith(AppComponent.isAdminUrl(this.router.url))
    );
    // startWith pokrywa SSR i stan PRZED pierwsza nawigacja (NavigationEnd jeszcze
    // nie padl) — readCurrentUrlOnce() dziala w kontekscie wstrzykiwania, czyli
    // tutaj, w konstruktorze.
    const initialHref = buildLangHrefs(readCurrentUrlOnce());
    this.langHref$ = this.router.events.pipe(
      filter((val): val is NavigationEnd => val instanceof NavigationEnd),
      map((val) => buildLangHrefs(val.urlAfterRedirects)),
      startWith(initialHref)
    );
  }

  private static isAdminUrl(url: string): boolean {
    return splitLocalePrefix(url).rest.startsWith('/admin');
  }

  /**
   * Klikniecie NIE robi preventDefault — nawigacje wykonuje przegladarka po href,
   * wiec dziala srodkowy przycisk, Ctrl/Cmd+klik i crawler. Tutaj tylko utrwalamy
   * wybor, zeby pozniejsze wejscie na adres BEZ prefiksu tez bylo w tym jezyku (H7).
   */
  rememberLanguage(lang: string): void {
    this.translationsService.rememberLanguage(lang);
  }

  ngOnInit(): void {

    this.translationsService.getTranslations().subscribe((translations) => {
      loadTranslations(translations);
      this.changeRef.markForCheck();
    });

    // Panel admina ma być zawsze po polsku — wymuszamy język w runtime przy
    // wejściu na /admin i przywracamy zapisany wybór po wyjściu (publiczna część).
    this.isAdminRoute$.subscribe((isAdmin) => {
      if (isAdmin) {
        this.translationsService.useRuntimeLanguage('pl');
      } else {
        this.translationsService.restoreSavedLanguage();
      }
    });

    this.router.events
      .pipe(
        filter((val): val is NavigationEnd => val instanceof NavigationEnd),
        map(() => this.rootRoute(this.activatedRoute)),
        filter((route: ActivatedRoute) => {
          return route.outlet === 'primary';
        }),
        mergeMap((route: ActivatedRoute) => route.data)
      )
      .subscribe((event: { seo?: Seo }) => {
        this.appChat.resetTime();
        this.seoService.updateSeo(event.seo);
      });




  }

  ngAfterViewInit() {
   this.appChat.init();

    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener('click', () => {
        this.appChat.resetTime();
      });

      document.addEventListener('scroll', () => {
        this.appChat.resetTime();
      });
    }
  }


  private rootRoute(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }
}
